import React from "react";
import { Box, TextField, FormControl, Typography, MenuItem, Select, InputLabel } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import Header from "../../../components/Header";
import { useAlert } from "../../../global/AlertContext";
import { useNavigate } from "react-router-dom";
import { useCreateProductMutation } from "../../../services/productService";
import { product_types, product_UOM } from "../../../constants/enums";
import SuccessButton from "../../../components/SuccessButton";
import CancelButton from "../../../components/CancelButton";

const CreateProduct = () => {
  const showAlert = useAlert();
  const navigate = useNavigate();


  const [createProduct] = useCreateProductMutation();

  const handleFormSubmit = async (product, { resetForm }) => {
    try {
      await createProduct(product).unwrap();
      showAlert("Producto creado!", "success");
      resetForm();
      navigate('/products'); 
  
    } catch (error) {
      console.error("Error creating product:", error);
      showAlert(error.message, "error");
    }
  };

  const initialValues = {
    name: "",
    UOM: "",
    type: ""
  };

  const productSchema = yup.object().shape({
    name: yup.string().required("Requerido"),
    UOM: yup.string().required("Requerido"),
    type: yup.string().required("Requerido")
  })

  return (
    <Box m="20px">
      <Header title="Productos" subtitle="Crear Producto" />
      <Formik
        onSubmit={(values, { resetForm }) => handleFormSubmit(values, { resetForm })}
        initialValues={initialValues}
        validationSchema={productSchema}
      >
        {({ values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
            >
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Nombre del Producto"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.name}
                name="name"
                error={!!touched.name && !!errors.name}
                helperText={touched.name && errors.name}
                sx={{ gridColumn: "span 2" }}
              />
              <FormControl fullWidth variant="filled" sx={{ gridColumn: "span 2" }}>
                <InputLabel>Unidad de medida</InputLabel>
                <Select
                  labelId="UOM-label"
                  id="UOM"
                  name="UOM"
                  label="Unidad de medida"
                  value={values.UOM}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={!!touched.UOM && !!errors.UOM}
                >
                  {product_UOM.map((t) => (
                  <MenuItem key={t.value} value={t.value}>{t.label}</MenuItem>
                  ))}
                </Select>
                {touched.UOM && errors.UOM && (
                  <Typography variant="caption" color="error">
                    {errors.UOM}
                  </Typography>
                )}
              </FormControl>
              <FormControl fullWidth variant="filled" sx={{ gridColumn: "span 2" }}>
                <InputLabel>Tipo</InputLabel>
                <Select
                  id="type"
                  name="type"
                  label="Tipo"
                  value={values.type}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={!!touched.type && !!errors.type}
                >
                  {product_types.map((t) => (
                  <MenuItem key={t.value} value={t.value}>{t.label}</MenuItem>
                  ))}
                </Select>
                {touched.type && errors.type && (
                  <Typography variant="caption" color="error">
                    {errors.type}
                  </Typography>
                )}
              </FormControl>
            </Box>
            <Box
              display="flex"
              justifyContent="end"
              textAlign="center"
              gap="4px"
            >
              <CancelButton label="Cancelar" onClick={() => navigate('/products')}/>
              <SuccessButton label="Crear Producto" />
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default CreateProduct;